import { useTranslation } from 'react-i18next';
import { toDateString } from '../../../../../utils/TimeUtils';
import { DEFAULT_DATE } from '../../../../../components/common/Constants';
import { DateTimePicker } from '../../../../../components/dateTimePicker/DateTimePicker';
import { FilterButton } from '../../../../../components/buttons/FilterButton';

export const ConsumedProductsFilter = ({ filter, doFilter }) => {
    const { t } = useTranslation();

    const setFrom = (value) => {
        filter.from = toDateString(value, DEFAULT_DATE);
    };

    const setTill = (value) => {
        filter.till = toDateString(value, DEFAULT_DATE);
    };

    return (
        <div className={'filter'} id={'filter-element'}>
            <div className={'mb-3'}>
                <span>{t('filter:from')}</span>
                <DateTimePicker value={filter.from}
                                onChange={setFrom}
                                dateFormat={DEFAULT_DATE}>
                </DateTimePicker>
            </div>
            <div className={'mb-3'}>
                <span>{t('filter:till')}</span>
                <DateTimePicker value={filter.till}
                                onChange={setTill}
                                dateFormat={DEFAULT_DATE}>
                </DateTimePicker>
            </div>
            <div className={'center'}>
                <FilterButton onClick={doFilter}></FilterButton>
            </div>
        </div>
    );
};